import { render, staticRenderFns } from "./file_cate.vue?vue&type=template&id=38878579&scoped=true&"
import script from "./file_cate.vue?vue&type=script&lang=js&"
export * from "./file_cate.vue?vue&type=script&lang=js&"
import style0 from "./file_cate.vue?vue&type=style&index=0&id=38878579&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38878579",
  null
  
)

export default component.exports